import {
  CREATE_MPF_PERFIL,
  DELETE_MPF_PERFIL,
  GET_MPF_PERFIS_CATALOGO,
  LIST_MPF_PERFIS,
  UPDATE_MPF_PERFIL,
} from '../../constants';

const pedido = { error: null, loaded: false, loading: false };

const initialState = {
  items: [],
  catalogo: null,
  list: pedido,
  catalogoRequest: pedido,
  create: pedido,
  update: pedido,
  delete: pedido,
};

const CHAVE_DO_PEDIDO: Record<string, keyof typeof initialState> = {
  [LIST_MPF_PERFIS]: 'list',
  [GET_MPF_PERFIS_CATALOGO]: 'catalogoRequest',
  [CREATE_MPF_PERFIL]: 'create',
  [UPDATE_MPF_PERFIL]: 'update',
  [DELETE_MPF_PERFIL]: 'delete',
};

/** Estado do painel de perfis de acesso (lista, catálogo e escritas). */
export const mpfPerfisReducer = (state = initialState, action: any = {}) => {
  const [tipo, fase] = String(action.type ?? '').split(
    /_(PENDING|SUCCESS|FAIL)$/,
  );
  const chave = CHAVE_DO_PEDIDO[tipo];
  if (!chave || !fase) return state;

  if (fase === 'PENDING') {
    return { ...state, [chave]: { error: null, loaded: false, loading: true } };
  }
  if (fase === 'FAIL') {
    return {
      ...state,
      [chave]: { error: action.error, loaded: false, loading: false },
    };
  }

  const concluido = { error: null, loaded: true, loading: false };
  if (tipo === LIST_MPF_PERFIS) {
    return { ...state, items: action.result ?? [], [chave]: concluido };
  }
  if (tipo === GET_MPF_PERFIS_CATALOGO) {
    return { ...state, catalogo: action.result ?? null, [chave]: concluido };
  }
  return { ...state, [chave]: concluido };
};

export default mpfPerfisReducer;
